import TimetableEntryTypeDropdown from "components/dropdowns/reactselect/TimetableEntryTypeDropdown";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import React from "react";

export interface TimetableTypeInputValue {
  type: server.dto.TimetableEntryType
  customText: string
}

interface Props {
  value: TimetableTypeInputValue
  validatorKey: string
  focusOnMount?: boolean
  onChange: (value: TimetableTypeInputValue, submit: boolean) => void
  submit?: () => void
  cancel?: () => void
}

export const TimetableTypeInput = (props: Props) => {
  const isCustom = props.value.type.value === "custom";

  return <div className="flex-column gap-mini">
    <TimetableEntryTypeDropdown
      value={props.value.type}
      onChange={(type: server.dto.TimetableEntryType) => {
        // A custom type still needs its label, so it is not saved yet
        props.onChange({ type, customText: "" }, type.value !== "custom");
      }}
      onEsc={() => props.cancel?.()}
      config={{
        focusOnMount: props.focusOnMount && !isCustom,
        openMenuOnFocus: props.focusOnMount && !isCustom,
      }}
    />
    {isCustom && <RequiredTextInput
      validatorKey={`${props.validatorKey}-custom-text`}
      focusOnMount
      maxLength={serverReference.constants.timetable.maxCustomNameLength}
      value={props.value.customText}
      onChange={(customText) => { props.onChange({ ...props.value, customText }, false); }}
      onEnter={() => props.submit?.()}
      onEsc={() => props.cancel?.()}
    />}
  </div>;
};
